import styled from 'styled-components';
import { getBackgroundColor, getTextColor, themeGet, color } from '@magalu/stereo-ui-styles';
import { layout, space, typography } from 'styled-system';
import { Link as LinkComp, Strip, Text, Image } from '../../atoms';
export const MultiColorHorizontalRule = styled(Strip)``;
const Container = styled.div.attrs(props => Object.assign({
  bg: 'background.primary'
}, props))`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  ${color}
  ${space}
`;
Container.ContentWrapper = styled.div`
  width: 100%;
  /* TODO: USE A THEME SETTING HERE */
  max-width: 1312px;
`;
Container.Content = styled.div.attrs(props => Object.assign({
  pt: '4',
  pb: '3'
}, props))`
  background-color: ${getBackgroundColor('primary')};
  ${space}
`;
Container.Bottom = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${getBackgroundColor('white')};
  width: 100%;
`;
Container.BottomContent = styled.div.attrs(props => Object.assign({
  maxWidth: '1000px',
  p: '3',
  lineHeight: 'fontSize'
}, props))`
  width: 100%;
  text-align: center;

  ${typography}
  ${layout}
  ${space}
`;
const PaymentMethods = styled.a`
  display: flex;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
`;
PaymentMethods.Content = styled.div`
  width: 100%;
  max-width: 990px;
  padding-bottom: 20px;
  border-bottom: 1px solid ${themeGet('baseColors.magablu.light')};
`;
PaymentMethods.Title = styled.p.attrs(props => Object.assign({
  color: 'text.lightest',
  fontSize: 3
}, props))`
  text-align: center;
  margin-bottom: 20px;
  ${color}
  ${typography}
`;
PaymentMethods.MethodsContainer = styled.div`
  display: flex;
  justify-content: center;
`;
PaymentMethods.MethodsContent = styled.ul.attrs(props => Object.assign({
  maxWidth: '620px'
}, props))`
  list-style: none;
  display: flex;
  justify-content: space-between;
  width: 100%;
  ${layout}
`;
PaymentMethods.Method = styled.li`
  width: 35px;
`;
PaymentMethods.MethodImage = styled(Image)``;
const CertificatePartners = styled.div`
  padding: 10px 0;
`;
CertificatePartners.CertificatesContainer = styled.div.attrs(props => Object.assign({
  mb: '3'
}, props))`
  display: flex;
  justify-content: center;
  ${space}
`;
CertificatePartners.CertificatesContent = styled.ul.attrs(props => Object.assign({
  maxWidth: '990px',
  minWidth: '300px'
}, props))`
  display: flex;
  list-style: none;
  justify-content: space-between;
  align-items: center;
  ${layout}
  ${typography}
`;
CertificatePartners.Title = styled(LinkComp).attrs(props => Object.assign({
  color: 'text.lightest',
  p: 0
}, props))`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 120px;

  & > *:not(:first-child) {
    margin-left: ${themeGet('space.2')}px;
  }
`;
CertificatePartners.TitleLabel = styled.span.attrs(props => Object.assign({
  color: 'text.lightest',
  fontSize: 0,
  maxWidth: '70px'
}, props))`
  ${layout}
  ${typography}
  ${color}
`;
export const Link = styled(LinkComp).attrs(props => Object.assign({
  color: 'text.lightest'
}, props))``;
const SubscriptionForm = styled.div.attrs(props => Object.assign({
  mb: '3'
}, props))`
  display: flex;
  justify-content: center;
  ${space}
`;
SubscriptionForm.Content = styled.div.attrs(props => Object.assign({
  maxWidth: '620px'
}, props))`
  width: 100%;
  ${layout}
`;
const LinksNav = styled.div`
  display: flex;
  justify-content: center;
`;
LinksNav.SectionsList = styled.ul.attrs(props => Object.assign({
  maxWidth: '990px'
}, props))`
  display: flex;
  justify-content: space-around;
  list-style: none;
  width: 100%;
  ${layout}
`;
LinksNav.Column = styled.li``;
LinksNav.SectionTitle = styled.p.attrs(props => Object.assign({
  color: 'text.lightest',
  fontSize: 1,
  fontWeight: 'regular'
}, props))`
  padding: 10px;
  ${color}
  ${typography}
`;
LinksNav.LinksList = styled.ul`
  display: inline-flex;
  writing-mode: vertical-lr;
  flex-wrap: wrap;
  align-content: flex-start;
  max-height: 270px;
  line-height: ${themeGet('lineHeights.thin')}px;

  ${Link} {
    font-size: ${themeGet('fontSizes.0')}px;
    color: ${themeGet('colors.lightBlue')};
  }
`;
LinksNav.LinkItem = styled.li`
  list-style: none;
  writing-mode: horizontal-tb;
  padding: 1px 0px;
`;
LinksNav.Content = styled.span.attrs(props => Object.assign({
  gap: '12px'
}, props))`
  &:not(:first-child) {
    margin-left: ${({
  gap
}) => gap};
  }
`;
LinksNav.Text = styled.div`
  ${layout}
  ${typography}
`;
LinksNav.Image = styled(Image).attrs(props => Object.assign({
  maxHeight: '12px'
}, props))`
  width: auto;
`;
export const Line = styled(Text).attrs(props => Object.assign({
  fontSize: 0
}, props))`
  padding: ${themeGet('space.1')}px ${themeGet('space.3')}px;
  color: ${getTextColor('light')};
  ${typography}
  ${color}
`;
export const InfoLink = styled.a`
  color: ${getTextColor('light')};
`;
export { Container, PaymentMethods, CertificatePartners, SubscriptionForm, LinksNav };